/**
 * One finding in a Home list: its severity, its title and, in For you, its
 * due day. The tooltip says where it comes from and when it was raised.
 *
 * @module components/home/HomeFindingRow
 */
import { Link } from "@tanstack/react-router";

import { ListRow, ListRowDate, ListRowIcon, ListRowTitle } from "../ui/list-row";
import { Tip } from "../ui/tip";
import { SeverityGlyph } from "../regulation/finding/findingGlyphs";
import type { FindingItem } from "../regulation/finding/findingItem";
import { isFindingOverdue } from "./homeGlance.logic";
import { findingDueColumn, findingRowTooltip } from "./homeTabs.logic";

export function HomeFindingRow({
  item,
  orgSegment,
  now,
  withDue = false,
}: {
  readonly item: FindingItem;
  readonly orgSegment: string;
  readonly now: number;
  /** For you: the due day in the date column, and severity and document in the tooltip. */
  readonly withDue?: boolean;
}) {
  const overdue = isFindingOverdue(item, now);
  return (
    <li>
      <Tip label={findingRowTooltip(item, now, withDue)}>
        <ListRow render={<Link to="/$org/compliance/findings/$findingId" params={{ org: orgSegment, findingId: item.id }} />}>
          <ListRowIcon>
            <SeverityGlyph severity={item.severity} tone="quiet" className="size-3.5" />
          </ListRowIcon>
          <ListRowTitle ink="soft">{item.title}</ListRowTitle>
          {withDue ? (
            <ListRowDate urgent={overdue}>
              {overdue ? <span className="sr-only">Overdue since </span> : null}
              {findingDueColumn(item, now)}
            </ListRowDate>
          ) : null}
        </ListRow>
      </Tip>
    </li>
  );
}
